const RETAILERS_SORT_BY = {
  DEFAULT: '',
  NAME: 'name',
  CASHBACK_STAKE: 'cashback_stake',
  TAG_COUNT: 'tags_count',
  PRIORITY: 'group_priority',
};

export default RETAILERS_SORT_BY;
